import { useQuery } from '@tanstack/react-query';

import { documentsApi } from '@/domain/documents/api';
import { queryOptions } from '@/services/query';

import { documentsKeys } from '@/domain/documents/queries/keys';

// Addresses the send-by-email dialog offers alongside chat participants and the
// addresses remembered in localStorage.
export const emailAutocompleteQuery = (companyId: string, documentIds: string[], linkID: string) =>
  queryOptions({
    queryKey: documentsKeys.emailAutocomplete(companyId, documentIds, linkID),
    queryFn: () => documentsApi.getEmailAutocomplete({ query: { document_ids: documentIds, linkID } }),
    // Read once when the dialog opens: the list cannot change while it is open,
    // and a focus-driven refetch would only churn the options under the cursor.
    refetchOnWindowFocus: false,
    // A failed read costs only the server's suggestions — the user can still
    // type, and the other two sources still fill the dropdown — so don't hold
    // the dialog on a spinner for a retry.
    retry: false,
  });

export const useEmailAutocomplete = (companyId: string, documentIds: string[], linkID: string) =>
  useQuery(emailAutocompleteQuery(companyId, documentIds, linkID));
